module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "ping-pub.7c1a9deb.svg";